import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API_BASE = `${ENV_API_BASE_URL}/api/header`;

const EMPTY_LINK = { label: "", path: "/" };
const EMPTY_NAV_LINK = {
  type: "link",
  label: "",
  path: "/",
  side: "left",
  order: 0,
};
const EMPTY_NAV_DROPDOWN = {
  type: "dropdown",
  label: "",
  side: "left",
  order: 0,
  dropdown: { label: "", links: [{ ...EMPTY_LINK }] },
};

const DEFAULT_NAV_ITEMS = [
  { type: "link", label: "Home", path: "/", side: "left", order: 0 },
  {
    type: "dropdown",
    label: "About",
    side: "left",
    order: 1,
    dropdown: {
      label: "About",
      links: [
        { label: "Founder", path: "/Our-Founder" },
        { label: "Our Teachers", path: "/teachers" },
        { label: "Our School", path: "/Our-School" },
        { label: "Accommodation", path: "/Accommodation-Food" },
        { label: "Blog", path: "/blog" },
        { label: "Yoga Books", path: "/Yoga-Books" },
        { label: "Gallery", path: "/gallery" },
      ],
    },
  },
  {
    type: "dropdown",
    label: "Rishikesh TTC",
    side: "left",
    order: 2,
    dropdown: {
      label: "Rishikesh TTC",
      links: [
        { label: "100 Hour TTC", path: "/course/100-hour-yttc" },
        { label: "200 Hour TTC", path: "/course/200-hour-yttc" },
        { label: "300 Hour TTC", path: "/course/300-hour-yttc" },
        { label: "500 Hour TTC", path: "/course/500-hour-yttc" },
      ],
    },
  },
  {
    type: "dropdown",
    label: "Short Course",
    side: "left",
    order: 3,
    dropdown: {
      label: "Short Course",
      links: [
        { label: "Meditation", path: "/course/meditation" },
        { label: "Pranayama", path: "/course/pranayama" },
      ],
    },
  },
  { type: "link", label: "Ayurveda", path: "/Ayurveda-Page", side: "right", order: 4 },
  {
    type: "dropdown",
    label: "Online Courses",
    side: "right",
    order: 5,
    dropdown: {
      label: "Online Courses",
      links: [
        { label: "Online YTTC", path: "/Online-YTTC" },
        { label: "Yoga Online", path: "/Yoga-Online" },
      ],
    },
  },
  { type: "link", label: "Payment", path: "/payment", side: "right", order: 6 },
  { type: "link", label: "Contact", path: "/contact-us", side: "right", order: 7 },
];

const createDefaultForm = () => ({
  address:
    "Hatha Yogashram, Balaknath Rd, Upper Tapovan, Rishikesh, Uttarakhand India 249192",
  phone: "+91 9335606336",
  yogaAllianceId: "Yoga Alliance ID: 401771",
  facebookUrl: "https://www.facebook.com/profile.php?id=100095297992781",
  instagramUrl: "https://www.instagram.com/hathayogashram/",
  logoUrl: "",
  logoFile: null,
  ctaLabel: "Register Now",
  ctaPath: "/BookingForm",
  navItems: DEFAULT_NAV_ITEMS.map((item) => ({
    ...item,
    dropdown: item.dropdown
      ? {
          ...item.dropdown,
          links: item.dropdown.links.map((link) => ({ ...link })),
        }
      : undefined,
  })),
});

const buildFormState = (data) => {
  const defaults = createDefaultForm();
  if (!data) return defaults;

  return {
    address: data.address || defaults.address,
    phone: data.phone || defaults.phone,
    yogaAllianceId: data.yogaAllianceId || defaults.yogaAllianceId,
    facebookUrl: data.facebookUrl || "",
    instagramUrl: data.instagramUrl || "",
    logoUrl: data.logoUrl || "",
    logoFile: null,
    ctaLabel: data.ctaLabel || defaults.ctaLabel,
    ctaPath: data.ctaPath || defaults.ctaPath,
    navItems:
      data.navItems?.length > 0
        ? data.navItems.map((item, index) => ({
      type: item.type || "link",
      label: item.label || "",
      side: item.side || "left",
      order: Number.isFinite(item.order) ? item.order : index,
      path: item.path || "/",
      dropdown: {
        label: item.dropdown?.label || item.label || "",
        links: (item.dropdown?.links || [{ ...EMPTY_LINK }]).map((link) => ({
          label: link.label || "",
          path: link.path || "/",
        })),
      },
    }))
        : defaults.navItems,
  };
};

export default function HeaderAdmin() {
  const [form, setForm] = useState(() => createDefaultForm());
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(API_BASE)
      .then((res) => {
        setForm(buildFormState(res.data?.data));
      })
      .catch((err) => {
        console.error("Failed to load header settings:", err);
      });
  }, []);

  const logoPreview = useMemo(() => {
    if (form.logoFile) {
      return URL.createObjectURL(form.logoFile);
    }
    return form.logoUrl || "";
  }, [form.logoFile, form.logoUrl]);

  useEffect(() => {
    return () => {
      if (logoPreview && form.logoFile) {
        URL.revokeObjectURL(logoPreview);
      }
    };
  }, [logoPreview, form.logoFile]);

  const handleField = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setForm((prev) => ({ ...prev, logoFile: files[0] || null }));
      return;
    }
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const addNavLink = (side) => {
    setForm((prev) => ({
      ...prev,
      navItems: [
        ...prev.navItems,
        { ...EMPTY_NAV_LINK, side, order: prev.navItems.length },
      ],
    }));
  };

  const addNavDropdown = (side) => {
    setForm((prev) => ({
      ...prev,
      navItems: [
        ...prev.navItems,
        { ...EMPTY_NAV_DROPDOWN, side, order: prev.navItems.length },
      ],
    }));
  };

  const removeNavItem = (index) => {
    setForm((prev) => ({
      ...prev,
      navItems: prev.navItems
        .filter((_, itemIndex) => itemIndex !== index)
        .map((item, itemIndex) => ({ ...item, order: itemIndex })),
    }));
  };

  const moveNavItem = (index, direction) => {
    setForm((prev) => {
      const items = [...prev.navItems];
      const target = index + direction;
      if (target < 0 || target >= items.length) return prev;
      [items[index], items[target]] = [items[target], items[index]];
      return {
        ...prev,
        navItems: items.map((item, itemIndex) => ({
          ...item,
          order: itemIndex,
        })),
      };
    });
  };

  const updateNavItem = (index, field, value) => {
    setForm((prev) => {
      const navItems = [...prev.navItems];
      navItems[index] = { ...navItems[index], [field]: value };
      if (field === "type" && value === "link") {
        navItems[index] = { ...navItems[index], path: navItems[index].path || "/" };
      }
      if (field === "type" && value === "dropdown") {
        navItems[index] = {
          ...navItems[index],
          dropdown: navItems[index].dropdown || {
            label: navItems[index].label || "",
            links: [{ ...EMPTY_LINK }],
          },
        };
      }
      return { ...prev, navItems };
    });
  };

  const updateDropdownLink = (navIndex, linkIndex, field, value) => {
    setForm((prev) => {
      const navItems = [...prev.navItems];
      const links = [...navItems[navIndex].dropdown.links];
      links[linkIndex] = { ...links[linkIndex], [field]: value };
      navItems[navIndex] = {
        ...navItems[navIndex],
        dropdown: { ...navItems[navIndex].dropdown, links },
      };
      return { ...prev, navItems };
    });
  };

  const addDropdownLink = (navIndex) => {
    setForm((prev) => {
      const navItems = [...prev.navItems];
      navItems[navIndex] = {
        ...navItems[navIndex],
        dropdown: {
          ...navItems[navIndex].dropdown,
          links: [...navItems[navIndex].dropdown.links, { ...EMPTY_LINK }],
        },
      };
      return { ...prev, navItems };
    });
  };

  const removeDropdownLink = (navIndex, linkIndex) => {
    setForm((prev) => {
      const navItems = [...prev.navItems];
      const nextLinks = navItems[navIndex].dropdown.links.filter(
        (_, currentIndex) => currentIndex !== linkIndex
      );
      navItems[navIndex] = {
        ...navItems[navIndex],
        dropdown: {
          ...navItems[navIndex].dropdown,
          links: nextLinks.length ? nextLinks : [{ ...EMPTY_LINK }],
        },
      };
      return { ...prev, navItems };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSaved(false);
    setError("");

    try {
      const formData = new FormData();
      formData.append("address", form.address);
      formData.append("phone", form.phone);
      formData.append("yogaAllianceId", form.yogaAllianceId);
      formData.append("facebookUrl", form.facebookUrl);
      formData.append("instagramUrl", form.instagramUrl);
      formData.append("ctaLabel", form.ctaLabel);
      formData.append("ctaPath", form.ctaPath);

      if (form.logoFile) {
        formData.append("logo", form.logoFile);
      } else {
        formData.append("logoUrl", form.logoUrl);
      }

      const navPayload = form.navItems.map((item, index) => {
        const base = {
          type: item.type,
          label: item.label,
          side: item.side,
          order: index,
        };

        if (item.type === "link") {
          return { ...base, path: item.path || "/" };
        }

        return {
          ...base,
          dropdown: {
            label: item.dropdown.label || item.label,
            links: item.dropdown.links.filter((link) => link.label.trim()),
          },
        };
      });

      formData.append("navItems", JSON.stringify(navPayload));
      await axios.put(API_BASE, formData);
      setForm((prev) => ({
        ...prev,
        navItems: prev.navItems.map((item, index) => ({ ...item, order: index })),
      }));
      setSaved(true);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to save header settings.");
    } finally {
      setLoading(false);
    }
  };

  const leftItems = form.navItems.filter((item) => item.side === "left");
  const rightItems = form.navItems.filter((item) => item.side === "right");

  return (
    <div className="container pt-5 mt-5" style={{ maxWidth: 1100 }}>
      <h3 className="mb-1">Header Settings</h3>
      <p className="text-muted small mb-4">
        Update the top bar, logo, CTA, and navigation menus used across the public site.
      </p>

      {error && <div className="alert alert-danger">{error}</div>}
      {saved && <div className="alert alert-success">Header saved successfully.</div>}

      <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        <h5 className="mb-3">Top Bar</h5>
        <div className="row">
          <div className="col-md-8 mb-3">
            <label className="form-label">Address</label>
            <input
              name="address"
              className="form-control"
              value={form.address}
              onChange={handleField}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Phone</label>
            <input
              name="phone"
              className="form-control"
              value={form.phone}
              onChange={handleField}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Yoga Alliance Label</label>
            <input
              name="yogaAllianceId"
              className="form-control"
              value={form.yogaAllianceId}
              onChange={handleField}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Facebook URL</label>
            <input
              name="facebookUrl"
              className="form-control"
              value={form.facebookUrl}
              onChange={handleField}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Instagram URL</label>
            <input
              name="instagramUrl"
              className="form-control"
              value={form.instagramUrl}
              onChange={handleField}
            />
          </div>
        </div>

        <h5 className="mt-4 pt-3 border-top">Logo And CTA</h5>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Logo URL</label>
            <input
              name="logoUrl"
              className="form-control"
              value={form.logoUrl}
              onChange={handleField}
              placeholder="https://..."
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Upload Logo</label>
            <input
              type="file"
              name="logo"
              className="form-control"
              accept="image/*"
              onChange={handleField}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">CTA Label</label>
            <input
              name="ctaLabel"
              className="form-control"
              value={form.ctaLabel}
              onChange={handleField}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">CTA Path</label>
            <input
              name="ctaPath"
              className="form-control"
              value={form.ctaPath}
              onChange={handleField}
            />
          </div>
          {logoPreview && (
            <div className="col-12 mb-2">
              <img
                src={logoPreview}
                alt="Header logo preview"
                style={{
                  height: 56,
                  objectFit: "contain",
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: 8,
                }}
              />
            </div>
          )}
        </div>

        <div className="mt-4 pt-3 border-top">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
            <div>
              <h5 className="mb-1">Navigation</h5>
              <p className="text-muted small mb-0">
                Create links or dropdown menus and place them on the left or right side.
              </p>
            </div>
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => addNavLink("left")}
              >
                + Left Link
              </button>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => addNavDropdown("left")}
              >
                + Left Dropdown
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => addNavLink("right")}
              >
                + Right Link
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => addNavDropdown("right")}
              >
                + Right Dropdown
              </button>
            </div>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <div className="border rounded p-3 h-100">
                <h6 className="mb-3">Left Menu Preview</h6>
                {leftItems.length === 0 && (
                  <p className="text-muted small mb-0">No left-side items added yet.</p>
                )}
                {leftItems.map((item, index) => (
                  <div key={`left-preview-${index}`} className="small mb-2">
                    {item.type === "dropdown" ? "Dropdown" : "Link"}: {item.label || "Untitled"}
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-6">
              <div className="border rounded p-3 h-100">
                <h6 className="mb-3">Right Menu Preview</h6>
                {rightItems.length === 0 && (
                  <p className="text-muted small mb-0">No right-side items added yet.</p>
                )}
                {rightItems.map((item, index) => (
                  <div key={`right-preview-${index}`} className="small mb-2">
                    {item.type === "dropdown" ? "Dropdown" : "Link"}: {item.label || "Untitled"}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {form.navItems.map((item, index) => (
            <div className="border rounded p-3 mb-3" key={`nav-item-${index}`}>
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                <strong>
                  Item {index + 1} {item.label ? `- ${item.label}` : ""}
                </strong>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => moveNavItem(index, -1)}
                  >
                    ↑
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => moveNavItem(index, 1)}
                  >
                    ↓
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => removeNavItem(index)}
                  >
                    Remove
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Type</label>
                  <select
                    className="form-select"
                    value={item.type}
                    onChange={(e) => updateNavItem(index, "type", e.target.value)}
                  >
                    <option value="link">Link</option>
                    <option value="dropdown">Dropdown</option>
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Label</label>
                  <input
                    className="form-control"
                    value={item.label}
                    onChange={(e) => updateNavItem(index, "label", e.target.value)}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Side</label>
                  <select
                    className="form-select"
                    value={item.side}
                    onChange={(e) => updateNavItem(index, "side", e.target.value)}
                  >
                    <option value="left">Left</option>
                    <option value="right">Right</option>
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Order</label>
                  <input className="form-control" value={item.order} readOnly />
                </div>
              </div>

              {item.type === "link" ? (
                <div className="mb-2">
                  <label className="form-label">Path</label>
                  <input
                    className="form-control"
                    value={item.path || "/"}
                    onChange={(e) => updateNavItem(index, "path", e.target.value)}
                  />
                </div>
              ) : (
                <>
                  <div className="mb-3">
                    <label className="form-label">Dropdown Label</label>
                    <input
                      className="form-control"
                      value={item.dropdown?.label || ""}
                      onChange={(e) =>
                        setForm((prev) => {
                          const navItems = [...prev.navItems];
                          navItems[index] = {
                            ...navItems[index],
                            dropdown: {
                              ...navItems[index].dropdown,
                              label: e.target.value,
                            },
                          };
                          return { ...prev, navItems };
                        })
                      }
                    />
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label mb-0">Dropdown Links</label>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => addDropdownLink(index)}
                    >
                      + Add Link
                    </button>
                  </div>

                  {item.dropdown?.links?.map((link, linkIndex) => (
                    <div className="row align-items-end mb-2" key={`dropdown-link-${index}-${linkIndex}`}>
                      <div className="col-md-5">
                        <label className="form-label">Label</label>
                        <input
                          className="form-control"
                          value={link.label}
                          onChange={(e) =>
                            updateDropdownLink(index, linkIndex, "label", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-5">
                        <label className="form-label">Path</label>
                        <input
                          className="form-control"
                          value={link.path}
                          onChange={(e) =>
                            updateDropdownLink(index, linkIndex, "path", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <button
                          type="button"
                          className="btn btn-outline-danger w-100"
                          onClick={() => removeDropdownLink(index, linkIndex)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Saving..." : "Save Header"}
          </button>
        </div>
      </form>
    </div>
  );
}
